import { render, staticRenderFns } from "./ClueOcpbCareManage.vue?vue&type=template&id=f98c9d74&"
import script from "./ClueOcpbCareManage.vue?vue&type=script&lang=js&"
export * from "./ClueOcpbCareManage.vue?vue&type=script&lang=js&"
import style0 from "./ClueOcpbCareManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports